<div class="flex flex-col gap-y-5" *ngIf="!activeCourseForm">
  <div *ngIf="course" class="flex justify-between animate-slide-in-left">
    <div class="flex flex-row items-center gap-x-3">
      <div class="flex flex-row items-center gap-x-2 text-dark text-2xl">
        <p>
          {{
          course && course.name
          ? course.name
          : course && course.course_name
          ? course.course_name
          : ""
          }}
        </p>
      </div>
    </div>
    <!--div class="flex justify-between items-center gap-x-4">
      <div *ngIf="course && course.start_date && course.end_date" class="flex flex-col gap-y-1">
        <p class="text-xs font-semibold text-dark text-center">ESTADO</p>
        <div class="text-xs">
          <div *ngIf="course.current_state" class="flex flex-row justify-center items-center gap-x-2 text-xs border rounded-xl p-1" [style.background-color]="course.current_state.color">
            <span class="text-white text-center">
              {{course.current_state.name}}
            </span>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-y-1">
        <p class="text-xs font-semibold text-dark text-center">INICIO</p>
        <p class="text-xs">
          {{ (course && course.start_date ? course.start_date : "") | date:'dd/MM/yyyy' }}
        </p>
      </div>
      <div class="flex flex-col gap-y-1">
        <p class="text-xs font-semibold text-dark text-center">FIN</p>
        <p class="text-xs">
          {{ (course && course.end_date ? course.end_date : "") | date:'dd/MM/yyyy' }}
        </p>
      </div>
    </div>-->
    <div class="grid grid-cols-3 gap-x-10 items-center text-center">
      <p class="text-xs font-semibold">ESTADO</p>
      <p class="text-xs font-semibold">FECHA INICIO</p>
      <p class="text-xs font-semibold">FECHA FIN</p>
      <div *ngIf="course.current_state" class="flex justify-center">
        <span class="text-xs text-white px-2 py-1 pl-4 pr-4 rounded-xl" [style.background-color]="course.current_state.color">
          {{ course.current_state.name }}
        </span>
      </div>
      <p class="text-xs">
        {{ course.start_date ? (course.start_date | date:'dd/MM/yyyy HH:mm') : '-' }}
      </p>
      <p class="text-xs">
        {{ course.end_date ? (course.end_date | date:'dd/MM/yyyy HH:mm') : '-' }}
      </p>
    </div>
  </div>


  <div class="flex justify-between items-center border-b border-gray-200">
    <div class="flex">
      <div *ngFor="let tab of detailsTabs; let i = index; trackBy: trackByTabLabel" (click)="activeTabIndex = i"
        [class.border-primary]="activeTabIndex === i" class="cursor-pointer px-4 py-2 text-[1rem] font-bold border-b-2"
        [ngClass]="
          activeTabIndex === i
            ? 'text-primary border-primary'
            : 'text-dark  border-transparent duration-200 hover:text-primary'
        ">
        {{ tab.label }}
      </div>

    </div>
    <!-- Botón para añadir alumnos inline -->
    <button *ngIf="studentForm && !activeStudentForm && currentTabLabel === 'Información del curso'" (click)="activeStudentForm = true"
      class="flex flex-row hover:shadow-lg duration-300 items-center justify-center rounded-2xl gap-x-2 py-2 px-3 text-white bg-primary hover:bg-primary-600 cursor-pointer w-44">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
        <path d="M9 12h6" />
        <path d="M12 9v6" />
      </svg>
      <p class="text-sm">{{ studentForm.createButtonTitle }}</p>
    </button>
  </div>
  <div *ngIf="currentTabLabel === 'Información del curso' && course" class="p-4 space-y-5">

    <!-- Formulario inline para añadir alumnos -->
    <div *ngIf="activeStudentForm && studentForm" class="bg-white rounded-xl border border-gray-200 p-4 animate-slide-in-top">
      <div class="flex items-center justify-between mb-3">
        <div class="flex items-center gap-x-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <h4 class="text-sm font-bold text-dark">{{ studentForm.formTitle }}</h4>
        </div>
        <button (click)="activeStudentForm = false"
          class="p-1.5 mr-2 rounded-full hover:bg-gray-100 transition-colors duration-200 text-gray-400 hover:text-gray-600">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
      <app-generic-form (onFinished)="onFinishStudentForm()" (onCancel)="activeStudentForm = false" [showCancel]="true" [genericForm]="studentForm"></app-generic-form>
    </div>

    <!-- Datos generales del curso -->
    <div class="flex justify-between items-center">
      <h3 class="text-base font-semibold text-dark">Información del Curso</h3>
      <button (click)="toggleActiveCourseForm()"
        class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary hover:text-white transition-colors duration-200">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        Editar
      </button>
    </div>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
      <div *ngIf="course.office" class="bg-white rounded-xl border border-gray-200 p-4">
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Sucursal</p>
        <p class="text-sm font-medium text-dark">{{ course.office.name }}</p>
      </div>
      <div *ngIf="course.course?.virtual_classroom" class="bg-white rounded-xl border border-gray-200 p-4">
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Aula</p>
        <p class="text-sm font-medium text-dark">{{ course.course.virtual_classroom.name }}</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-4">
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Capacidad</p>
        <p class="text-sm font-medium text-dark">{{ course.n_students || 0 }} / {{ course.capacity }}</p>
      </div>
      <div class="bg-white rounded-xl border border-gray-200 p-4">
        <p class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Tope inscripci&oacute;n</p>
        <p class="text-sm font-medium text-dark">{{ course.registration_deadline ? (course.registration_deadline | date:'dd/MM/yyyy') : '-' }}</p>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <!-- Alumnos con evaluación inline -->
      <div class="bg-white rounded-xl border border-gray-200 p-4">
        <div class="flex items-center gap-x-2 mb-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <h4 class="text-sm font-bold text-dark">Alumnos <span class="text-gray-400 font-normal">({{ course.students?.length || 0 }})</span></h4>
        </div>
        <!-- Seleccionar todos -->
        <div *ngIf="course.students?.length" class="flex items-center gap-x-2 py-1.5 px-2 mb-1 border-b border-gray-100">
          <input type="checkbox" [checked]="areAllStudentsSelected()" (change)="toggleAllStudents()"
            class="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer" />
          <span class="text-xs text-gray-400">Seleccionar todos</span>
        </div>
        <!-- Lista de alumnos -->
        <div class="flex flex-col gap-y-1 max-h-64 overflow-y-auto">
          <div *ngFor="let student of course.students"
            class="flex items-center gap-x-2 py-1.5 px-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
            (click)="toggleStudentSelection(student.id)">
            <input type="checkbox" [checked]="selectedStudentIds.has(student.id)"
              (click)="$event.stopPropagation()" (change)="toggleStudentSelection(student.id)"
              class="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer" />
            <div class="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <span class="text-xs font-semibold text-primary">{{ student.name?.charAt(0)?.toUpperCase() }}</span>
            </div>
            <div class="flex-1 min-w-0">
              <span class="text-sm text-dark truncate block">{{ student.name }} {{ student.surname }}</span>
            </div>
            <span *ngIf="student.qualification_name" class="text-xs text-white bg-green-500 px-2 py-0.5 rounded-full flex-shrink-0">
              {{ student.qualification_name }}
            </span>
            <button (click)="$event.stopPropagation(); openPrivateChat(student.id, student.name)"
              class="p-1 rounded-full hover:bg-primary/10 transition-colors duration-200 flex-shrink-0" title="Chat con alumno">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </button>
          </div>
          <p *ngIf="!course.students?.length" class="text-sm text-gray-400 italic py-2">Sin alumnos inscritos</p>
        </div>
        <!-- Barra de acción inline para calificar -->
        <div *ngIf="selectedStudentIds.size > 0" class="mt-3 pt-3 border-t border-gray-100 animate-slide-in-top">
          <p class="text-xs text-gray-500 mb-2">{{ selectedStudentIds.size }} alumno{{ selectedStudentIds.size > 1 ? 's' : '' }} seleccionado{{ selectedStudentIds.size > 1 ? 's' : '' }}</p>
          <div class="flex items-center gap-x-2">
            <div class="flex-1">
              <app-custom-dropdown
                [(ngModel)]="selectedQualificationId"
                [options]="qualifications"
                optionLabel="name"
                optionValue="id"
                placeholder="Calificación..."
                [filter]="false"
                [showClear]="true">
              </app-custom-dropdown>
            </div>
            <button (click)="assignQualification()" [disabled]="!selectedQualificationId || assigningQualification"
              class="px-3 py-1.5 text-sm font-medium text-white bg-primary hover:bg-primary-600 rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0">
              {{ assigningQualification ? 'Asignando...' : 'Asignar' }}
            </button>
            <button (click)="clearStudentSelection()" title="Deseleccionar todos"
              class="p-1.5 rounded-lg hover:bg-gray-100 transition-colors duration-200 text-gray-400 hover:text-gray-600 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Profesores -->
      <div class="bg-white rounded-xl border border-gray-200 p-4">
        <div class="flex items-center gap-x-2 mb-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <h4 class="text-sm font-bold text-dark">Profesores <span class="text-gray-400 font-normal">({{ course.teachers?.length || 0 }})</span></h4>
        </div>
        <div class="flex flex-col gap-y-2">
          <div *ngFor="let teacher of course.teachers" class="flex items-center gap-x-2 py-1.5 px-2 rounded-lg hover:bg-gray-50 transition-colors">
            <div class="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center">
              <span class="text-xs font-semibold text-primary">{{ teacher.name?.charAt(0)?.toUpperCase() }}</span>
            </div>
            <span class="text-sm text-dark">{{ teacher.name }} {{ teacher.surname }}</span>
          </div>
          <p *ngIf="!course.teachers?.length" class="text-sm text-gray-400 italic">Sin profesores asignados</p>
        </div>
      </div>
    </div>

    <!-- Unidades de Aula Virtual -->
    <div *ngIf="course?.course?.virtual_classroom?.units?.length" class="bg-white rounded-xl border border-gray-200 p-4">
      <div class="flex items-center gap-x-2 mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        </svg>
        <h4 class="text-sm font-bold text-dark">Unidades de Aula Virtual <span class="text-gray-400 font-normal">({{ course.course.virtual_classroom.units.length }})</span></h4>
      </div>
      <div class="flex flex-wrap gap-2">
        <div *ngFor="let unit of course.course.virtual_classroom.units"
          class="flex items-center gap-x-2 py-1.5 px-3 rounded-lg bg-gray-50 text-sm text-dark">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
          </svg>
          {{ unit.name }}
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="currentTabLabel === 'Aula Virtual'">
    <div *ngIf="course?.course?.virtual_classroom" class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div *ngFor="let unit of course.course.virtual_classroom.units"
        class="flex flex-col md:flex-row justify-between rounded-lg border-gray-light shadow-md border-[1px] p-4 gap-4">
        <!-- Información del módulo -->
        <div class="flex flex-col gap-y-4 md:w-1/3">
          <p class="text-xl font-bold text-primary">{{ unit.name }}</p>
          <p class="text-sm text-gray">{{ unit.description }}</p>
        </div>

        <!-- Tabla -->
        <div class="w-full md:w-2/3">
          <table class="w-full border-collapse table-fixed">
            <tbody>
              <tr>
                <td class="border-b border-r border-gray-200 w-1/2">
                  <div
                    class="flex flex-row items-center p-4 gap-x-4 hover:bg-gray-100 duration-200 cursor-pointer rounded-tl-lg"
                    (click)="openBookModal(unit.documents)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 text-primary" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
                      <path d="M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0" />
                      <path d="M3 6l0 13" />
                      <path d="M12 6l0 13" />
                      <path d="M21 6l0 13" />
                    </svg>
                    <p>Libro de texto</p>
                  </div>
                </td>
                <td class="border-b border-gray-200 w-1/2">
                  <div
                    class="flex flex-row items-center p-4 gap-x-4 hover:bg-gray-100 duration-200 cursor-pointer rounded-tr-lg"
                    (click)="openVideoModal(unit.videos)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 text-primary" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M2 8a4 4 0 0 1 4 -4h12a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-12a4 4 0 0 1 -4 -4v-8z" />
                      <path d="M10 9l5 3l-5 3z" />
                    </svg>
                    <p>Videos formativos</p>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="border-r border-gray-200">
                  <div
                    class="flex flex-row items-center p-4 gap-x-4 hover:bg-gray-100 duration-200 cursor-pointer rounded-bl-lg"
                    (click)="openImageModal(unit.images)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 text-primary" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                      <path
                        d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" />
                      <path d="M17 7h.01" />
                      <path d="M7 13l3.644 -3.644a1.21 1.21 0 0 1 1.712 0l3.644 3.644" />
                      <path d="M15 12l1.644 -1.644a1.21 1.21 0 0 1 1.712 0l2.644 2.644" />
                    </svg>
                    <p>Imágenes y esquemas</p>
                  </div>
                </td>
                <td>
                  <div
                    class="flex flex-row items-center p-4 gap-x-4 hover:bg-gray-100 duration-200 cursor-pointer rounded-br-lg"
                    (click)="openChatModal(unit.id)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 text-primary" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M8 9h8" />
                      <path d="M8 13h6" />
                      <path
                        d="M12.01 18.594l-4.01 2.406v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5" />
                      <path d="M16 19h6" />
                      <path d="M19 16v6" />
                    </svg>
                    <p>Preguntas frecuentes</p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Icono lateral -->
        <div class="flex justify-end md:justify-center md:items-start" (click)="toggleActiveUnitForm(unit.id)">
          <div class="flex justify-center items-center p-1 rounded-lg cursor-pointer duration-200 hover:bg-gray-light">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 text-secondary" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" />
              <path d="M13.5 6.5l4 4" />
              <path d="M16 19h6" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="currentTabLabel === 'Horarios y asistencias'">
    <div class="flex flex-row gap-x-4 pb-3">
      <p class="text-sm text-gray">Sucursal: <span class="text-dark">{{course.office.name}}</span></p>
      <p class="text-sm text-gray">Profesor/a: <span class="text-dark">{{
          getTeachersFromLesson(course.lessons[lessonIndexTab]).join(', ') }}</span></p>
    </div>
    <div class="flex border-b border-gray-200 mb-1">
      <div *ngFor="let lesson of course.lessons; let i = index" (click)="lessonIndexTab = i; selectedLesson = lesson"
        [class.border-primary]="lessonIndexTab === i" class="cursor-pointer px-4 pb-2 text-sm font-bold border-b-2"
        [ngClass]="
            lessonIndexTab === i
              ? 'text-primary border-primary'
              : 'text-dark  border-transparent duration-200 hover:text-primary'
          ">
        {{ getLessonDateTime(lesson) | date: 'EEEE, d MMMM y HH:mm' }}
      </div>
    </div>
    <app-generic-crud *ngIf="studentCruds && studentCruds[lessonIndexTab]" [genericCrud]="studentCruds[lessonIndexTab]"></app-generic-crud>
  </div>
  <div *ngIf="currentTabLabel === 'Chat'">
    <div class="bg-white w-full rounded-lg shadow-lg border border-gray-200 relative p-3 overflow-y-auto">

      <div class="flex flex-col">
        <div class="flex w-full justify-between items-center gap-x-3 px-1">
          <div class="p-1 rounded-full bg-bg">
            <!-- icono usuario -->
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 text-dark" viewBox="0 0 24 24" fill="currentColor">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
              <path d="M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z" />
            </svg>
          </div>
          <textarea [(ngModel)]="newCommentText" rows="1" placeholder="Añade un comentario..."
            class="w-full h-full border-b focus:border-dark outline-none border-gray animate-duration-300 resize-none"></textarea>
        </div>
        <div class="flex justify-end">
          <button class="text-xs px-2 py-1 rounded-md hover:bg-bg duration-300 text-dark" (click)="sendComment(null)">
            Enviar
          </button>
        </div>
      </div>
      <div class="flex flex-col gap-y-1">
        <ng-container *ngFor="let courseChat of course.course_chats">
          <div class="flex flex-col rounded-md px-1 py-1">
            <div class="flex flex-row items-center gap-x-3 text-sm text-dark mb-1 animate-slide-in-left rounded-md">
              <div class="p-1 rounded-full bg-bg">
                <!-- icono usuario -->
                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 text-dark" viewBox="0 0 24 24" fill="currentColor">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
                  <path d="M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z" />
                </svg>
              </div>
              <div class="flex-1">
                <div class="flex flex-row gap-x-2 items-center">
                  <p>{{ courseChat.user.name }}</p>
                  <p class="text-gray text-sm">{{ getTimeAgo(courseChat.created_at)}}</p>
                  <p *ngIf="courseChat.unit" class="text-gray text-sm">{{ courseChat.unit.name}}</p>
                </div>
                <p class="text-base">{{ courseChat.comment }}</p>
              </div>
              <button *ngIf="courseChat.replies.length"
                class="text-xs text-secondary hover:bg-blue-50 flex items-center gap-1 p-1 rounded-full duration-300"
                (click)="toggleReplies(courseChat.id)">
                <svg xmlns="http://www.w3.org/2000/svg" [attr.class]="
                    isRepliesVisible(courseChat.id)
                      ? 'w-4 h-4 rotate-180 transition-transform'
                      : 'w-4 h-4 rotate-0 transition-transform'
                  " viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round">
                  <path d="M6 9l6 6 6-6" />
                </svg>
                {{ courseChat.replies.length }} respuestas
              </button>
            </div>
            <button class="text-xs text-dark hover:bg-bg rounded-md p-1 duration-300 self-start mb-2 ml-11"
              (click)="toggleReplyInput(courseChat.id)">
              {{ activeReplyInput === courseChat.id ? "Cancelar" : "Responder" }}
            </button>

            <div *ngIf="activeReplyInput === courseChat.id"
              class="flex w-full justify-between items-center gap-x-1 p-[0.2rem] mt-2 pl-11">
              <div class="p-1 rounded-full bg-bg">
                <!-- icono usuario -->
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 text-dark" viewBox="0 0 24 24" fill="currentColor">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
                  <path d="M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z" />
                </svg>
              </div>
              <textarea
                class="w-full h-full border-b focus:border-dark outline-none border-gray animate-duration-300 resize-none"
                [(ngModel)]="replyText[courseChat.id]" rows="1"></textarea>
              <button class="text-xs px-2 py-1 rounded-md hover:bg-bg duration-300 text-dark"
                (click)="sendReply(courseChat.id,courseChat.unit_id ? courseChat.unit_id : null)">
                Enviar
              </button>
            </div>

            <div *ngIf="isRepliesVisible(courseChat.id)" class="pl-11 mt-2">
              <div *ngFor="let reply of courseChat.replies"
                class="flex flex-row items-center gap-x-3 text-sm text-dark mb-4 animate-slide-in-left rounded-md">
                <div class="p-1 rounded-full bg-bg">
                  <!-- icono usuario reply -->
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 text-dark" viewBox="0 0 24 24" fill="currentColor">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
                    <path d="M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z" />
                  </svg>
                </div>
                <div>
                  <div class="flex flex-row gap-x-2 items-center text-xs">
                    <p>{{ reply.user.name }}</p>
                    <p class="text-gray">{{ getTimeAgo(reply.created_at)}}</p>
                  </div>
                  <p class="text-sm">{{ reply.comment }}</p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- Course Form -->
<app-modal *ngIf="activeCourseForm && courseForm" 
  [title]="courseForm.formTitle" 
  [fullscreen]="true"
  (close)="toggleActiveCourseForm()">
  <app-generic-form (onFinished)="onFinishCourseForm()" (onCancel)="toggleActiveCourseForm()" [showCancel]="true" [genericForm]="courseForm"
    [selectedItem]="course"></app-generic-form>
</app-modal>
<!-- Unit Form -->
<app-modal *ngIf="activeUnitForm && unitForm"
  [title]="unitForm.formTitle || unitForm.updateFormTitle || 'Editar Unidad'"
  [size]="unitForm.width"
  (close)="toggleActiveUnitForm()">
  <app-generic-form (onFinished)="onFinishUnitForm()" (onCancel)="toggleActiveUnitForm()" [showCancel]="true" [genericForm]="unitForm"
    [selectedItem]="selectedUnit"></app-generic-form>
</app-modal>

<!-- Book Modal -->
<div *ngIf="showBookModal" class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div class="bg-white relative rounded-3xl shadow-2xl w-full max-w-7xl h-[90vh] my-8 animate-slide-in-top flex flex-col">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">Libro de texto</h2>
      <button (click)="closeBookModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <!-- Contenido del modal -->
    <div class="px-8 py-6 flex-1 overflow-y-auto">
    <ng-container *ngFor="let media of medias">
      <div *ngIf="media.mime_type !== 'application/octet-stream'"
        class="flex flex-col w-full h-full text-sm text-dark mb-4">
        <p>{{ media.file_name }}</p>
        <iframe *ngIf="media && media.original_url" [src]="media.original_url | safeUrl"
          class="w-full h-full border rounded-md" frameborder="0">
        </iframe>
      </div>
      <div *ngIf="media.mime_type === 'application/octet-stream'"
        class="flex flex-row w-full items-center gap-x-4 text-sm text-dark mb-4">
        <p>{{ media.file_name }}</p>
        <button class="bg-primary text-white px-4 py-2 rounded-md" (click)="downloadFile(media)">
          Descargar
        </button>
      </div>
    </ng-container>
    </div>
  </div>
</div>

<!-- Video Modal -->
<div *ngIf="showVideoModal" class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div class="bg-white relative rounded-3xl shadow-2xl w-full max-w-7xl h-[95vh] my-8 animate-slide-in-top flex flex-col">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">Vídeos formativos</h2>
      <button (click)="closeVideoModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <!-- Contenido del modal -->
    <div class="px-8 py-6 flex-1 overflow-y-auto">
    <ng-container *ngFor="let media of medias">
      <div class="flex flex-col text-sm text-dark mb-4">
        <p>{{ media.name }}</p>
        <video *ngIf="media && media.original_url" [src]="media.original_url | safeUrl"
          class="w-full h-full border rounded-md" controls></video>
      </div>
    </ng-container>
    </div>
  </div>
</div>

<!--  Image Modal -->
<div *ngIf="showImageModal" class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div class="bg-white relative rounded-3xl shadow-2xl w-full max-w-7xl h-[95vh] my-8 animate-slide-in-top flex flex-col">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">Imágenes y esquemas</h2>
      <button (click)="closeImageModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <!-- Contenido del modal -->
    <div class="px-8 py-6 flex-1 overflow-y-auto">
    <ng-container *ngFor="let media of medias">
      <div class="flex flex-col text-sm text-dark mb-4">
        <p>{{ media.name }}</p>
        <img *ngIf="media && media.original_url" [src]="media.original_url | safeUrl"
          class="w-full h-full border rounded-md" />
      </div>
    </ng-container>
    </div>
  </div>
</div>

<!--  Chat Modal -->
<div *ngIf="showChatModal && selectedUnit"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div class="bg-white relative rounded-3xl shadow-2xl w-full max-w-3xl h-[95vh] my-8 animate-slide-in-top flex flex-col">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">Preguntas frecuentes</h2>
      <button (click)="closeChatModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <!-- Contenido del modal -->
    <div class="px-8 py-6 flex-1 overflow-y-auto">
    <div class="flex flex-col">
      <div class="flex w-full justify-between items-center gap-x-3 px-1">
        <textarea [(ngModel)]="newQuestionText" rows="1" placeholder="Añade una pregunta..."
          class="w-full h-full border-b focus:border-dark outline-none border-gray animate-duration-300 resize-none"></textarea>
      </div>
      <div class="flex justify-end">
        <button class="text-xs px-2 py-1 rounded-md hover:bg-bg duration-300 text-dark"
          (click)="sendQuestion(selectedUnit.id)">
          Añadir
        </button>
      </div>
    </div>
    <div class="flex flex-col gap-y-1">
      <ng-container *ngFor="let courseQuestion of courseQuestions">
        <!-- Pregunta -->
        <div class="bg-gray-100 border-l-4 border-gray-500 p-4 rounded-md mb-2">
          <p class="font-semibold text-lg">{{ courseQuestion.content }}</p>
          <div class="flex justify-between mt-2 space-x-4">
            <button class="text-sm text-gray-600 hover:underline" (click)="toggleAnswerInput(courseQuestion.id)">
              {{ activeAnswerInput === courseQuestion.id ? 'Cancelar' : 'Añadir una respuesta' }}
            </button>

            <button class="text-sm text-red-600 hover:underline" (click)="deleteCourseQuestion(courseQuestion.id)">
              Eliminar
            </button>
          </div>

          <div *ngIf="activeAnswerInput === courseQuestion.id"
            class="flex w-full justify-between items-center gap-x-1 p-[0.2rem] mt-2 pl-11">
            <textarea
              class="w-full h-full border-b focus:border-dark outline-none border-gray animate-duration-300 resize-none bg-gray-100"
              [(ngModel)]="answerText[courseQuestion.id]" rows="1"></textarea>
            <button class="text-xs px-2 py-1 rounded-md hover:bg-bg duration-300 text-dark"
              (click)="sendAnswer(courseQuestion.id,courseQuestion.unit_id)">
              Enviar
            </button>
          </div>
        </div>
        <!-- Respuestas -->
        <div class="ml-8 border-l border-gray-300 pl-4 space-y-3 mb-4">
          <div *ngFor="let answer of courseQuestion.answers" class="bg-gray-50 p-3 rounded-md shadow-sm">
            <p class="text-gray-700">{{ answer.content }}</p>
            <button class="text-xs text-red-600 hover:underline"
              (click)="deleteCourseQuestion(answer.id)">Eliminar</button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Chat Privado Modal -->
<div *ngIf="showPrivateChatModal && selectedTeacher"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div class="bg-white relative rounded-3xl shadow-2xl w-full max-w-2xl h-[80vh] my-8 animate-slide-in-top flex flex-col">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <div class="flex items-center gap-x-3">
        <div class="p-2 rounded-full bg-primary">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2">
            <path d="M12 2a5 5 0 1 1 -5 5l.005 -.217a5 5 0 0 1 4.995 -4.783z" />
            <path d="M14 14a5 5 0 0 1 5 5v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1a5 5 0 0 1 5 -5h4z" />
          </svg>
        </div>
        <div>
          <h2 class="text-xl font-bold text-gray-800">Chat con {{ selectedTeacher.name }}</h2>
          <p class="text-sm text-gray-600">Curso: {{ course.name }}</p>
        </div>
      </div>
      <button (click)="closePrivateChatModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Mensajes -->
    <div class="flex-1 p-4 overflow-y-auto space-y-4">
      <div *ngIf="privateChatMessages.length === 0" class="text-center text-gray-500 py-8">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-12 h-12 mx-auto mb-4 text-gray-300" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="1">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        <p>No hay mensajes aún. ¡Inicia la conversación!</p>
      </div>

      <div *ngFor="let message of privateChatMessages"
        [ngClass]="message.senderId === userId ? 'flex justify-end' : 'flex justify-start'">
        <div [ngClass]="message.senderId === userId ? 'bg-primary text-white' : 'bg-gray-100 text-dark'"
          class="max-w-xs lg:max-w-md px-4 py-2 rounded-lg">
          <p class="text-sm">{{ message.message }}</p>
          <p class="text-xs mt-1 opacity-70">{{ getTimeAgo(message.timestamp || message.created_at) }}</p>
        </div>
      </div>
    </div>

    <!-- Input de mensaje -->
    <div class="p-4 border-t border-gray-200">
      <div class="flex gap-x-2">
        <textarea [(ngModel)]="newPrivateMessageText" (keydown.enter)="$event.preventDefault(); sendPrivateMessage()"
          placeholder="Escribe tu mensaje..."
          class="flex-1 p-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          rows="2">
        </textarea>
        <button (click)="sendPrivateMessage()" [disabled]="!newPrivateMessageText.trim()"
          class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2">
            <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

